import './App.css';
import { BrowserRouter as Router } from "react-router-dom"
import Routing from './routes';
import './assets/vendors/bootstrap/css/bootstrap.min.css'
import './assets/vendors/fontawesome/css/all.min.css'
import './assets/vendors/jarallax/jarallax.css'
import './assets/vendors/animate/animate.min.css'
import './assets/vendors/owl-carousel/assets/owl.carousel.min.css'
import './assets/vendors/owl-carousel/assets/owl.theme.default.min.css'
import './assets/vendors/cretech-icons/style.css'
import './assets/vendors/youtube-popup/youtube-popup.css'
import './assets/css/cretech.css'
import { useEffect, useState } from 'react';

function App() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const preloader = document.querySelector('.preloader');
    if (preloader) {
      preloader.style.transition = 'opacity 0.4s ease';
      preloader.style.opacity = '0';
      const t = setTimeout(() => { preloader.style.display = 'none'; }, 400);
      return () => clearTimeout(t);
    }
  }, []);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 300);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <Router>
      <Routing />
      {showTop && (
        <button className="back-to-top" onClick={scrollToTop} aria-label="Back to top">
          <i className="fa fa-arrow-up"></i>
        </button>
      )}
    </Router>
  );
}

export default App;